import {Pipe, PipeTransform} from '@angular/core';

/**
 * Normalizes a URL and adds a protocol if necessary.
 */
@Pipe({name: 'normalizeUrl'})
export class NormalizeUrlPipe implements PipeTransform {

  constructor() {
  }

  transform(input: string): string {
    return NormalizeUrlPipe.apply(input);
  }

  static apply(value: string): string {
    if (!value || /^\.*\/|^(?!localhost)\w+:/.test(value)) {
      return value;
    }
    return value.replace(/^(?!(?:\w+:)?\/\/)/, 'http://');
  }
}
